import { render, staticRenderFns } from "./pro_badge.vue?vue&type=template&id=6dfaadb4&scoped=true&"
import script from "./pro_badge.vue?vue&type=script&lang=js&"
export * from "./pro_badge.vue?vue&type=script&lang=js&"
import style0 from "./pro_badge.vue?vue&type=style&index=0&id=6dfaadb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfaadb4",
  null
  
)

export default component.exports